import React from 'react';
import { useTranslation } from 'react-i18next';
import './DailyAbandonWidget.css';

const DailyAbandonWidget = ({ data, config }) => {
    const { t } = useTranslation();

    if (!Array.isArray(data) || data.length === 0) {
        return null;
    }

    const slaThreshold = config?.config?.abandonSlaThreshold ?? 5;
    const ringingSlaSeconds = config?.config?.ringingSlaSeconds ?? 15;

    const fmt = (val) => {
        if (val === null || val === undefined) return '-';
        return Number(val).toLocaleString();
    };

    const fmtPct = (val) => {
        if (val === null || val === undefined) return '-';
        const n = Number(val);
        return `${n % 1 === 0 ? n.toFixed(0) : n.toFixed(1)}%`;
    };

    const fmtDuration = (val) => {
        if (val === null || val === undefined) return '-';
        const total = Math.round(Number(val));
        const m = Math.floor(total / 60);
        const s = total % 60;
        return `${m}:${s.toString().padStart(2, '0')}`;
    };

    return (
        <div className="daily-abandon-widget">
            <div className="daily-abandon-table-container">
                <table className="daily-abandon-table">
                    <thead>
                        <tr>
                            <th rowSpan={2} className="col-day">{t('DAY')}</th>
                            <th colSpan={8} className="group-header">{t('ABANDONED_CALLS_STATISTICS')}</th>
                            <th rowSpan={2}>{t('REDIRECTED_CALLS')}</th>
                            <th rowSpan={2}>{t('AVG_RINGING_TIME')}</th>
                        </tr>
                        <tr>
                            <th>{t('ABANDON_CALLS')}</th>
                            <th>{t('SECONDS_0_15')}</th>
                            <th>{t('SECONDS_15_30')}</th>
                            <th>{t('SECONDS_30_45')}</th>
                            <th>{t('SECONDS_45_60')}</th>
                            <th>{t('PCT_ABANDON')}</th>
                            <th>{t('PCT_ABANDON_LT_15')}</th>
                            <th>{t('PCT_ABANDON_LT_30')}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {data.map((row, idx) => (
                            <tr key={idx}>
                                <td className="col-day">{row.day ?? '-'}</td>
                                <td className="col-number">{fmt(row.abandonCalls)}</td>
                                <td className="col-number">{fmt(row.count_0_15)}</td>
                                <td className="col-number">{fmt(row.count_15_30)}</td>
                                <td className="col-number">{fmt(row.count_30_45)}</td>
                                <td className="col-number">{fmt(row.count_45_60)}</td>
                                <td className="col-pct-val">{fmtPct(row.pct_abandon)}</td>
                                <td className="col-pct-val">{fmtPct(row.pct_abandon_lt_15)}</td>
                                <td className="col-pct-val">{fmtPct(row.pct_abandon_lt_30)}</td>
                                <td className="col-number">{fmt(row.redirectedCalls)}</td>
                                <td className="col-number">{fmtDuration(row.avgRingingTime)}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default DailyAbandonWidget;
